<template>
<div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/sale/invoices">{{ $t('sale_invoice_list') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('new') }}</li>
        </ol>
    <div class="x_header">
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i> {{ $t('back') }}</button>
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="handlePrint"><i class="fa fa-print"></i> {{ $t('print') }}</button>
        <template v-if="invoice.Status=='Draft'">
            <router-link v-if="invoice.DocSource=='Manual'" :to="{ name: 'sale_invoice_update', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-pencil"></i> {{$t('edit')}}</router-link>
            <button v-if="$store.state.userGroup==1" type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onApproval"><i class="fa fa-check"></i> {{ $t('approval') }}</button>
        </template>
        <template v-else>
            <router-link v-if="invoice.DocSource=='Manual' && !isCompleted" :to="{ name: 'sale_invoice_to_stockout', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-car"></i> {{$t('request_stockout')}}</router-link>
            <router-link v-if="$store.state.userGroup==1 && invoice.Balance>0" :to="{ name: 'sale_invoice_receipt_create', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-dollar"></i> {{$t('sale_receipted')}}</router-link>
        </template>
    </div>
    <div class="x_body">
        <div class="card f_card">
            <div class="card-body">
                <h3 class="text-center" style="font-weight: bold;">{{$t('invoice')}}</h3>
                <p class="text-center">{{$now().format('DD/MM/YYYY HH:mm A')}}</p>
                <div class="row">
                    <div class="col-sm-6">
                        <table class="table-print">
                            <tbody>
                            <tr>
                                <th style="width: 200px;">អតិថិជន/Customer Name</th>
                                <td class="v-top" style="width: 15px;">:</td>
                                <td class="v-top">{{customer.Name}}</td>
                            </tr>
                            <tr>
                                <th style="width: 200px;">
                                    អាស័យដ្ឋាន/Address
                                </th>
                                <td class="v-top" style="width: 15px;">:</td>
                                <td class="v-top">{{customer.Address}}</td>
                            </tr>
                            <tr>
                                <th style="width: 200px;">លេខទូរស័ព្ទ/Phone</th>
                                <td class="v-top" style="width: 15px;">:</td>
                                <td class="v-top">{{customer.Phone}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-sm-6">
                        <table class="table-print" align="right">
                            <tbody>
                            <tr>
                                <th style="width: 120px; text-align: right">លេខរៀងវិក្កយបត្រ</th>
                                <td style="width: 15px;">:</td>
                                <td>{{invoice.Num}}</td>
                            </tr>
                            <tr>
                                <th style="width: 120px; text-align: right">កាលបរិច្ឆេទចេញវិក្កយបត្រ</th>
                                <td>:</td>
                                <td>{{$format(invoice.Date, 'DD/MM/YYYY')}}</td>
                            </tr>
                            <tr>
                                <th style="width: 140px; text-align: right">កាលបរិច្ឆេទបញ្ជូលទំនិញ</th>
                                <td>:</td>
                                <td>{{$format(invoice.DueDate, 'DD/MM/YYYY')}}</td>
                            </tr>
                            <tr>
                                <th style="width: 120px; text-align: right">PO Order Ref No.</th>
                                <td></td>
                                <td>{{invoice.DocSourceNo}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <table class="table table-bordered table-sm no-bor table-scroll">
                            <thead>
                                <tr>
                                    <th class="text-center th-width">{{$t('no')}}</th>
                                    <th class="th-width">{{$t('item_code')}}</th>
                                    <th class="th-width">{{$t('item_name')}}</th>
                                    <th class="text-center th-width">{{$t('qty_sale')}}</th>
                                    <th class="text-center th-width">{{$t('qty_out')}}</th>
                                    <th class="text-center th-width">{{$t('uom')}}</th>
                                    <th class="text-right th-width">{{$t('cost')}}</th>
                                    <th class="text-right th-width">{{$t('price_sale')}}</th>
                                    <th class="text-right th-width">{{$t('discount')}}</th>
                                    <th class="text-right th-width">{{$t('sub_total')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret,index) in lines" :key="ret.Id">
                                    <td class="text-center">{{index+1}}</td>
                                    <td>{{ret.ItemCode}}</td>
                                    <td>{{ret.ItemName}}</td>
                                    <td class="text-center">{{ret.Quantity}}</td>
                                    <td class="text-center" :class="{'bg-red':ret.Quantity>ret.StockoutQty}">{{ret.StockoutQty}}</td>
                                    <td class="text-center">{{ret.UomName}}</td>
                                    <td class="text-right">{{$money(ret.Cost)}}</td>
                                    <td class="text-right">{{$money(ret.Price)}}</td>
                                    <td class="text-right">{{$number(ret.Discount)}}%</td>
                                    <td class="text-right">{{$money(ret.SubTotal)}}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colspan="9" class="text-right">{{$t('grand_total')}}:</th>
                                    <th style="width: 120px;" class="text-right">{{$money(invoice.GrandTotal)}}</th>
                                </tr>
                                <tr>
                                    <th colspan="9" class="text-right">{{$t('discount')}}:</th>
                                    <th style="width: 120px;" class="text-right">{{$money(invoice.Discount)}}</th>
                                </tr>
                                <tr>
                                    <th colspan="9" class="text-right">{{$t('total')}}:</th>
                                    <th style="width: 120px;" class="text-right blue">{{$money(invoice.TotalAmount)}}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group" style="display: flex">
                            <label class="control-lable" style="margin-right: 10px">{{ $t('noted') }}: </label>
                            <div>{{invoice.Description}}</div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="invoice.Status!='Draft'">
                    <div class="col-sm-12">
                        <br>
                        <p class="blue" style="font-weight: bold; margin-bottom: 3px;"><i class="fa fa-car" aria-hidden="true"></i> {{$t('stock_out')}}</p>
                        <table class="table table-bordered table-sm table-striped no-bor table-scroll">
                        <thead>
                            <tr>
                                <th class="text-center th-width">{{ $t('no') }}</th>
                                <th class="th-width">{{ $t('code') }}</th>
                                <th class="th-width">{{ $t('date') }}</th>
                                <th class="th-width">{{ $t('type') }}</th>
                                <th class="th-width">{{ $t('ref_num') }}</th>
                                <th class="th-width">{{ $t('branch')}}</th>
                                <th class="th-width">{{ $t('requestor') }}</th>
                                <th class="th-width">{{ $t('customer') }}</th>
                                <th class="th-width">{{$t('status')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in stockouts" :key="index">
                                <td>{{index+1}}</td>
                                <td><router-link :to="{ name: 'stock_out_preview', params: { id: ret.Id }}">{{ret.Num}}</router-link></td>
                                <td>{{$format(ret.OutDateAt, 'DD-MM-YYYY') }}</td>
                                <td>{{ret.DocSource}}</td>
                                <td>{{ret.DocSourceNo}}</td>
                                <td>{{ret.BranchName}}</td>
                                <td>{{ret.TakerOut}}</td>
                                <td>{{ret.CustomerName}}</td>
                                <td class="cell-badge" v-html="$statusLabel(ret.Status)"></td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
                <div class="row" v-if="invoice.Status!='Draft'">
                    <div class="col-sm-12">
                        <br>
                        <p class="blue" style="font-weight: bold; margin-bottom: 3px;"><i class="fa fa-usd" aria-hidden="true"></i> {{$t('sale_receipt')}}</p>
                        <table class="table table-bordered table-striped table-sm no-bor table-scroll">
                            <thead>
                            <tr>
                                <th class="th-width">{{$t('no')}}</th>
                                <th class="th-width">{{$t('code')}}</th>
                                <th class="th-width">{{$t('date')}}</th>
                                <th class="th-width">{{$t('payment_method')}}</th>
                                <th class="th-width">{{$t('description')}}</th>
                                <th class="th-width">{{$t('ref_num')}}</th>
                                <th class="th-width">{{$t('amount')}}</th>
                                <th class="th-width">{{$t('status')}}</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret, index) in receipts" :key="index">
                                    <td>{{index+1}}</td>
                                    <td>
                                        <router-link :to="{ name: 'sale_receipt_preview', params:{ id:ret.Id }}">{{ret.Num}}</router-link>
                                    </td>
                                    <td>{{$format(ret.Date, 'DD/MM/YYYY')}}</td>
                                    <td>{{ret.AccountName}}</td>
                                    <td>{{ret.Description}}</td>
                                    <td>{{ret.DocSourceNo}}</td>
                                    <td class="text-right">{{$money(ret.Amount)}}</td>
                                    <td class="cell-badge" v-html="$statusLabel(ret.Status)"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                 </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    import print from '../PDF/Prints/Receipt.js';
    export default {
        data(){
            return {
                invoice: {},
                lines: [],
                customer: {},
                stockouts: [],
                receipts: []
            }
        },
        created(){
            let id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
                let loading = this.$loading.show();
                var req = {
                    Id: id,
                    IsIncludeStockoutLine: true,
                    IsIncludeStockout: true,
                    IsIncludeReceipt: true
                };
                this.$api().post('sale/invoice/find', req).then(res => {
                    var data = res.data.Data;
                    this.customer = res.data.Json.Customer;
                    this.invoice = data.SaleInvoice;
                    this.lines = data.SaleInvoiceLines;
                    this.stockouts = res.data.Json.Stockouts;
                    this.receipts = res.data.Json.Receipts;
                }).finally(function(){ loading.hide(); });
            }
        },
        methods: {
            handlePrint(){
                //window.open('/print/nonTaxInvoice/' + this.invoice.Id, '_blank');
                print(this.$store.state.company, this.invoice, this.lines, this.$money);
            },
            onApproval(){
                let id = this.$route.params.id;
                let loading = this.$loading.show();
                this.$api().post('sale/invoice/approval', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.$router.go(-1);
                    }
                }).finally(function(){ loading.hide(); });
            }
        },
        computed: {
            isCompleted(){
                var res = true;
                for(var i =0;i<this.lines.length;i++){
                    var item = this.lines[i];
                    if(item.Quantity > item.StockoutQty){
                        res = false;
                        break;
                    }
                }
                return res;
            }
        }
    }
</script>
<style scoped>
    label{
        margin-bottom: 0;
    }
</style>
